import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
import { AuthService } from "./app/services";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  document.title = "GreeZon | Backoffice";
  checkSessionUpdate();
});

const checkSessionUpdate = () => AuthService().updateUserLocalSession();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_NotificationToast = _resolveComponent("NotificationToast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_NotificationToast)
  ], 64))
}
}

})